import { SymbolsAnimationFactory } from './SymbolsAnimationFactory'
import { SymbolContainerData } from '@/modules'
import { HOLD_AND_WIN_ALLOWED_MULTIPLIERS } from '@/utils/HoldAndWinCoinValue'

export class MultiplierSymbolsFactory extends SymbolsAnimationFactory {
    private static readonly AVAILABLE_MULTIPLIERS: number[] = HOLD_AND_WIN_ALLOWED_MULTIPLIERS

    public getAnimationResource(): string {
        return 'coin'
    }

    public getAnimationLabel(symbolData: SymbolContainerData, state: string): string {
        const baseLabel = MultiplierSymbolsFactory.ANIMATIONS[state]
        if (!baseLabel) {
            return null
        }

        return `${baseLabel}${this.resolveCoinVariant(symbolData)}`
    }

    private resolveCoinVariant(symbolData: SymbolContainerData): number {
        const symbolKey = String(symbolData?.symbolKey || '').toLowerCase()
        const coinType = String(symbolData?.coinType || '').toLowerCase()

        if (symbolKey === 'k' && coinType === 'prize') {
            return 5
        }

        if (coinType.includes('prize') || coinType.includes('gold')) {
            return 5
        }

        if (coinType.includes('grand') || coinType.includes('jackpot')) {
            return 4
        }

        if (coinType.includes('major')) {
            return 3
        }

        if (coinType.includes('minor')) {
            return 2
        }

        if (coinType.includes('mini')) {
            return 1
        }

        const rawMultiplier = Number(symbolData?.coinValue ?? symbolData?.multiplier)
        if (Number.isFinite(rawMultiplier) && rawMultiplier > 0) {
            if (rawMultiplier >= 1000) return 4
            if (rawMultiplier >= 250) return 3
            if (rawMultiplier >= 100) return 2
            return 1
        }

        return 1
    }

    public static readonly ANIMATIONS: Record<string, string> = {
        land: 'landing',
        idle: 'idle',
        win: 'win',
        trigger: 'win',
    }
}
